'use client';

import classnames from 'classnames';
import { useTranslations } from 'next-intl';
import React, { Fragment } from 'react';

import Modal, { ModalProps } from '@/components/Modal';

import { CinemaLinkDto } from '@cineamo/api/models/cinema-link/CinemaLinkDto.types';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

type JobsModalProps = ModalProps & {
    domainConfiguration: DomainConfigurationDto;
    jobLinks: CinemaLinkDto[];
};

const JobsModal: React.FC<JobsModalProps> = (props) => {
    const { domainConfiguration, jobLinks } = props;

    const t = useTranslations();

    return (
        <Modal
            {...props}
            className="!h-[50dvh]"
            title={t('home.go-to')}
            titleClassName="text-headline-32"
            domainConfiguration={domainConfiguration}
            onClose={null}>
            <div className={classnames('w-full h-full flex flex-col overflow-auto')}>
                <div
                    className="flex-none w-full h-1 opacity-20"
                    style={
                        domainConfiguration.style
                            ? {
                                  backgroundColor: domainConfiguration.style.onSurfaceColor
                              }
                            : undefined
                    }
                />
                {jobLinks.map((jobLink, index) => (
                    <Fragment key={`JobLink#${index}`}>
                        <a
                            className="relative group cursor-pointer"
                            href={jobLink.url}>
                            <div
                                className="absolute w-full h-full bg-black opacity-0 duration-150 group-hover:opacity-10"
                                style={
                                    domainConfiguration.style
                                        ? {
                                              backgroundColor: domainConfiguration.style.onSurfaceColor
                                          }
                                        : undefined
                                }
                            />
                            <span className="block my-12 text-body-bold-12">{jobLink.name}</span>
                        </a>
                        {index < jobLinks.length && (
                            <div
                                className="flex-none w-full h-1 opacity-20"
                                style={
                                    domainConfiguration.style
                                        ? {
                                              backgroundColor: domainConfiguration.style.onSurfaceColor
                                          }
                                        : undefined
                                }
                            />
                        )}
                    </Fragment>
                ))}
            </div>
        </Modal>
    );
};

export default JobsModal;
